import {
  API_BASE_URL,
} from 'src/globals';

import { GET } from './apiHandler';
import { FETCH_BULK_REQUESTS, DOWNLOAD_BULK_REQUESTS } from './routes';

export const fetchBulkRequests = async (body) => {
  return GET(`${API_BASE_URL}${FETCH_BULK_REQUESTS}`, body);
};

export const downloadBulkRequests = async (body) => {
  return GET(`${API_BASE_URL}${DOWNLOAD_BULK_REQUESTS}`, body);
};
